<template>
  <div class="n-program-overview">
    <div v-if="description">
      <AppTitle mode="h3">
        <template v-slot:top>{{ t("more") }}</template>
        <template v-slot:title>{{ t("about.course") }}</template>
      </AppTitle>
      <div class="n-program-overview__content">
        <div class="n-program-overview__text" v-html="description"></div>
      </div>
      <CourseSummary
        v-if="user"
        @joinToCourse="$emit('joinToCourse')"
        @leaveCourse="$emit('leaveCourse')"
        @addToFavorites="$emit('addToFavorites')"
        @removeFromFavorites="$emit('removeFromFavorites')"
      />
    </div>
    <LoaderRing v-else />
  </div>
</template>

<script>
import { t } from "@/utils/translate";
import { computed } from "vue";
import { useUserStore } from "@/store/userStore";
import { storeToRefs } from "pinia";

import CourseSummary from "@/elements/CourseSummary.vue";
import AppTitle from "@/elements/AppTitle.vue";
import LoaderRing from "@/elements/LoaderRing.vue";

export default {
  components: { AppTitle, LoaderRing, CourseSummary },
  emits: [
    "joinToCourse",
    "leaveCourse",
    "addToFavorites",
    "removeFromFavorites",
  ],
  setup() {
    const userStore = useUserStore();
    const { currentCourse, user } = storeToRefs(userStore);
    const description = computed(() => currentCourse.value.description);

    return {
      t,
      description,
      user,
    };
  },
};
</script>

<!-- ВПИСЫВАЕМ В ОБЩУЮ СТИЛИСТИКУ НАВИГАТОРА «ЭВРИКИ» -->
<style lang="scss">
.n-program-overview__text {
  font-family: "Comfortaa", "Helvetica Neue", Arial, sans-serif !important; // Поддержка фирменного шрифта Comfortaa
  font-size: 16px !important;
  line-height: 1.65 !important; // Делаем текст легким для сканирования
  color: #334155 !important; // Спокойный и дорогой цвет Slate 700 вместо черного
  display: block !important;

  // Абзацы текста
  p {
    margin: 0 0 16px 0 !important;
    display: block !important;

    &:last-child {
      margin-bottom: 0 !important;
    }
  }

  // Контейнеры списков
  ul, ol {
    list-style: none !important;
    padding: 0 !important;
    margin: 16px 0 24px 24px !important; // Умеренные и чистые отступы
    display: block !important;
  }

  // Элементы списка
  li {
    position: relative !important;
    margin: 0 0 10px 0 !important; // Аккуратное расстояние между строками списка
    padding: 0 0 0 24px !important; // Небольшой аккуратный сдвиг текста вправо
    text-align: left !important;
    display: block !important;

    &:last-child {
      margin-bottom: 0 !important;
    }

    // ТИПОГРАФИЧЕСКИЙ МАРКЕР: ДЛИННОЕ ТИРЕ (—) ВМЕСТО СТРАННЫХ ТОЧЕК
    &::before {
      content: "—" !important; // Изящное длинное тире, как в печатных изданиях Эврики
      position: absolute !important;
      left: 2px !important; // Легкое смещение маркера к левому краю строки
      top: 0 !important; // Естественное выравнивание по базовой линии шрифта
      color: #64748b !important; // Чуть более приглушенный цвет для маркеров (Slate 500)
      font-size: 15px !important;
      font-weight: 400 !important;
      line-height: 1.65 !important;
    }
  }

  // СТИЛИЗАЦИЯ РОЗОВЫХ ПОДЗАГОЛОВКОВ ("Эффективно", "Сомнительно")
  strong, b {
    display: block !important;
    font-size: 18px !important;
    font-weight: 900 !important; // Максимальная жирность для акцента
    color: #f77587 !important; // Фирменный розовый цвет
    text-decoration: underline !important;
    text-underline-offset: 4px !important; // Отодвигаем линию вниз, чтобы верстка дышала
    margin-top: 32px !important; // «Воздух» сверху для разделения мыслей
    margin-bottom: 16px !important; // Небольшой аккуратный отступ до начала списка
  }
}
</style>



